import { render, staticRenderFns } from "./app-radio.vue?vue&type=template&id=6ae5402c&scoped=true&"
import script from "./app-radio.vue?vue&type=script&lang=js&"
export * from "./app-radio.vue?vue&type=script&lang=js&"
import style0 from "./app-radio.vue?vue&type=style&index=0&id=6ae5402c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae5402c",
  null
  
)

export default component.exports